<script>
import { authorized, authorizedThroughEsia, getRedirectUrl, deleteTokens, getLogoutUrl } from '@/auth';

export default {
	data() {
		return {}
	},
	async created() {
		if (authorizedThroughEsia()) {
			this.$router.push('/send');
		}

		if (authorized()) {
			const url = getLogoutUrl(this.$router.currentRoute.path);
			deleteTokens();
			window.location.href = url;
		}

		let redirectUrl = new URL(await getRedirectUrl(), window.location.origin);
		redirectUrl.searchParams.append('kc_idp_hint', 'esia-provider');
		window.location.href = redirectUrl.toString();
	}
}
</script>